import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

// redux actions (bunları kendi store/contacts/actions’ında oluştur)
import {
  getSubEducation as onGetSubEducation,
  addSubEducation as onAddSubEducation,
  updateSubEducation as onUpdateSubEducation,
  deleteSubEducation as onDeleteSubEducation,
  getProductCategory as ongetProductCategory,
  getSalesPoint as onGetSalesPoint,
  //getQuestionTypes as onGetQuestionTypes,
} from "store/contacts/actions";

import { useSelector, useDispatch } from "react-redux";

const QuizTemplateItemTypeList = () => {
  const tableRef = useRef(null);
  document.title = "QuizTemplateItem_Type | Admin Paneli";

  const dispatch = useDispatch();

  // store’dan listeler
  const { itemTypes, items, questionTypes } = useSelector((state) => ({
    itemTypes: state.contacts.educationSubItem || [],
    items: state.contacts.productCategory || [],
    questionTypes: state.contacts.salesPoint || [],
  }));

  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const [rowForDelete, setRowForDelete] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isActive, setIsActive] = useState(false);

  // dropdownlar
  const [quizTemplateItemId, setQuizTemplateItemId] = useState("");
  const [questionTypeId, setQuestionTypeId] = useState("");

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      quizTemplateItemId: editingRow?.QuizTemplateItemID ?? quizTemplateItemId ?? "",
      questionTypeId: editingRow?.Question_Type_ID ?? questionTypeId ?? "",
      desc: editingRow?.QuizTemplateItem_Type_Desc ?? "",
    },
    validationSchema: Yup.object({
      quizTemplateItemId: Yup.number().typeError("Item seçiniz").required("Item seçiniz"),
      questionTypeId: Yup.number().typeError("Soru tipi seçiniz").required("Soru tipi seçiniz"),
      desc: Yup.string().nullable().max(500, "Açıklama 500 karakterden fazla olamaz"),
    }),
    onSubmit: (values) => {
      const payload = {
        QuizTemplateItemID: Number(values.quizTemplateItemId),
        Question_Type_ID: Number(values.questionTypeId),
        QuizTemplateItem_Type_Desc: values.desc || "",
            };

      if (isEdit && editingRow?.ID) {
        dispatch(onUpdateSubEducation({ ID: editingRow.ID, ...payload }));
      } else {
        dispatch(onAddSubEducation(payload));
      }

      validation.resetForm();
      setIsEdit(false);
      setEditingRow(null);
      toggle();
    },
  });

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Item",
        accessor: "QuizTemplateItemID",
        filterable: true,
        Cell: (cellProps) => {
          const id = cellProps.row.original.QuizTemplateItemID;
          const item = items.find((i) => i.ID === id);
          return <span>{item?.Title || `Item #${id}`}</span>;
        },
      },
      {
        Header: "Soru Tipi",
        accessor: "Question_Type_ID",
        filterable: true,
        Cell: (cellProps) => {
          const id = cellProps.row.original.Question_Type_ID;
          const type = questionTypes.find((q) => q.ID === id);
          return <span>{type?.Question_Type_Title || `Type #${id}`}</span>;
        },
      },
      {
        Header: "İşlemler",
        Cell: (cellProps) => {
          const row = cellProps.row.original;
          return (
            <div className="d-flex gap-3">
              <Link to="#" className="text-success" onClick={() => handleEditClick(row)}>
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-danger" onClick={() => onClickDelete(row)}>
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    [items, questionTypes]
  );

  useEffect(() => {
    dispatch(onGetSubEducation());
    dispatch(ongetProductCategory());
    dispatch(onGetSalesPoint());
  }, [dispatch]);

  const toggle = () => setModal(!modal);

  const handleAddClick = () => {
    setEditingRow(null);
    setIsEdit(false);
    setIsActive(false);
    setQuizTemplateItemId("");
    setQuestionTypeId("");
    validation.resetForm();
    toggle();
  };

  const handleEditClick = (row) => {
    setEditingRow(row);
    setIsEdit(true);
    setIsActive(!!row.IsActive);
    setQuizTemplateItemId(row.QuizTemplateItemID || "");
    setQuestionTypeId(row.Question_Type_ID || "");
    validation.setValues({
      quizTemplateItemId: row.QuizTemplateItemID || "",
      questionTypeId: row.Question_Type_ID || "",
      desc: row.QuizTemplateItem_Type_Desc || ""
    });
    toggle();
  };

  const onClickDelete = (row) => {
    setRowForDelete(row);
    setDeleteModal(true);
  };

  const handleDelete = () => {
    if (rowForDelete?.ID) {
      dispatch(onDeleteSubEducation(rowForDelete.ID));
    }
    setDeleteModal(false);
    setRowForDelete(null);
  };

  const onChangeItem = (e) => {
    const val = e.target.value;
    setQuizTemplateItemId(val);
    validation.setFieldValue("quizTemplateItemId", val);
  };

  const onChangeQuestionType = (e) => {
    const val = e.target.value;
    setQuestionTypeId(val);
    validation.setFieldValue("questionTypeId", val);
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="QuizTemplateItem_Type Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={itemTypes || []}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddQuizTemplateItemType={true}
                    handleOrderClicks={handleAddClick}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {isEdit ? "Düzenle" : "QuizTemplateItem_Type Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>
                            <div className="mb-3">
                              <Label className="form-label">QuizTemplateItem</Label>
                              <Input
                                name="quizTemplateItemId"
                                type="select"
                                className="form-select"
                                value={validation.values.quizTemplateItemId || ""}
                                onChange={onChangeItem}
                              >
                                <option value="">Lütfen Seçim Yapınız</option>
                                {(items || []).map((i) => (
                                  <option value={i.ID} key={i.ID}>
                                    {i.Title}
                                  </option>
                                ))}
                              </Input>
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Soru Tipi</Label>
                              <Input
                                name="questionTypeId"
                                type="select"
                                className="form-select"
                                value={validation.values.questionTypeId || ""}
                                onChange={onChangeQuestionType}
                              >
                                <option value="">Lütfen Seçim Yapınız</option>
                                {(questionTypes || []).map((q) => (
                                  <option value={q.ID} key={q.ID}>
                                    {q.Question_Type_Title}
                                  </option>
                                ))}
                              </Input>
                            </div>


                              <div className="mb-3">
                                                          <Label className="form-label">Açıklama</Label>
                                                          <Input
                                                            name="desc"
                                                            type="text"
                                                            placeholder="Açıklama"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.desc || ""}
                                                            invalid={
                                                              validation.touched.desc &&
                                                                validation.errors.desc
                                                                ? true
                                                                : false
                                                            }
                                                          />
                                                          {validation.touched.desc &&
                                                            validation.errors.desc ? (
                                                            <FormFeedback type="invalid">
                                                              {validation.errors.desc}
                                                            </FormFeedback>
                                                          ) : null}
                                                        </div>

                   
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button type="submit" className="btn btn-success save-user">
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(QuizTemplateItemTypeList);
